import classNames from 'classnames';
import { sanitizeAnnouncementHtml } from '@/utils/sanitizeAnnouncementHtml';

export type AnnouncementRichTextProps = {
  html?: string | null;
  className?: string;
  preview?: boolean;
  previewLines?: 2 | 3;
  dir?: 'rtl' | 'ltr';
};

export function AnnouncementRichText({
  html,
  className,
  preview = false,
  previewLines = 3,
  dir = 'rtl',
}: AnnouncementRichTextProps) {
  const safe = sanitizeAnnouncementHtml(html);
  if (!safe) return null;

  return (
    <div
      className={classNames(
        'rt-rendered-content',
        preview && 'rt-rich-text-preview',
        preview && previewLines === 2 && 'rt-rich-text-preview--two',
        className,
      )}
      dir={dir}
      dangerouslySetInnerHTML={{ __html: safe }}
    />
  );
}

export default AnnouncementRichText;
